import { useEffect, useRef } from 'react'
import { useColorScheme } from '@mui/material'

import { config } from '@/config'
import { useUser } from '@/hooks/use-user'

export function NotakuWidget() {
	const scriptId = 'notaku-widget-script'
	const scriptLoaded = useRef(false)
	const { user } = useUser()
	const { colorScheme } = useColorScheme()

	const updateTheme = () => {
		if (!window.Notaku) return
		window.Notaku?.goTo(`https://updates.micromart.com?theme=${colorScheme}`)
		setTimeout(() => {
			window.Notaku?.goTo(`https://updates.micromart.com?username=${user?.username}&name=${user?.name}`)
		}, 1000)
	}

	useEffect(() => {
		updateTheme()
	}, [colorScheme])

	useEffect(() => {
		if (!config.notaku?.widgetId) return
		if (!user) return
		if (scriptLoaded.current) return
		scriptLoaded.current = true

		if (document.getElementById(scriptId)) {
			return
		} // extra safeguard

		const script = document.createElement('script')
		script.id = scriptId // Assign an ID to prevent duplication
		script.src = `https://notaku.so/widget.js?widgetId=${config.notaku?.widgetId}`
		script.dataset.widgetId = config.notaku?.widgetId
		script.async = true
		script.onload = () => {
			updateTheme()
		}
		document.body.appendChild(script)

		return () => {
			const existingScript = document.getElementById(scriptId)
			if (existingScript) {
				existingScript.remove()
			}
		}
	}, [user])

	return null // No UI needed
}
